import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MmDialogConfig, MmDialogService } from '@metromarkets/components';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { EmployeeGaTrackingService } from '~app/modules/authorization/services/employee-ga-tracking.service';
import { EmployeeService } from '~app/modules/authorization/services/employee.service';
import { environment } from '~env/environment';
import EmployeeOverviewNavigationAlertDialogComponent from '~shared/components/employee-overview-page-redirection-alert-dialog/employee-overview-navigation-alert-dialog.component';
import { APP_EMPLOYEE_OVERVIEW, ORDER_HISTORY_LINK_EXTERNAL } from '~shared/constants';
import { AccountType, IAccountInformation, IEmployee } from '~shared/models';

@Component({
  selector: 'app-employee-flyout',
  templateUrl: './employee-flyout.component.html',
  styleUrls: ['./employee-flyout.component.scss'],
})
export class EmployeeFlyoutComponent implements OnInit {
  employeeAccountDetails: IEmployee;
  avatarIcon = `${environment.cdnBaseUrl()}/images/metrox/icon_avatar.svg`;
  @Input() isOpen = false;
  accountType$ = this.accountInfoService.accountType$;
  accountDetails: IAccountInformation;
  @Output() onMenuClosed = new EventEmitter<any>();
  unsubscribe$ = new Subject();
  handleStopImpersonatingCustomer = this.employeeService.handleStopImpersonatingCustomer;
  isImpersonating = false;
  public readonly orderHistoryLinkExternal = ORDER_HISTORY_LINK_EXTERNAL();

  constructor(
    private accountInfoService: AccountInfoService,
    private eRef: ElementRef,
    private router: Router,
    private employeeService: EmployeeService,
    private employeeGaTrackingService: EmployeeGaTrackingService,
    private readonly mmDialogService: MmDialogService,
  ) {
    this.accountInfoService
      .getEmployeeAccountInfo()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((info: IEmployee) => {
        this.employeeAccountDetails = info;
      });
    this.accountInfoService
      .getAccountInfo()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((info) => {
        this.accountDetails = info;
      });
    this.accountType$.pipe(takeUntil(this.unsubscribe$)).subscribe((type) => {
      this.isImpersonating = type === AccountType.EMPLOYEE_AS_CUSTOMER;
    });
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeMenu();
    }
  }

  ngOnInit(): void {}

  closeMenu() {
    this.isOpen = false;
    this.onMenuClosed.emit(this.isOpen);
  }

  redirectToOrderHistory(e: Event) {
    this.employeeGaTrackingService.gaTrackingOrderHistoryEvent();
    this.closeMenu();
  }

  stopImpersonation(e: Event) {
    this.employeeService.handleStopImpersonatingCustomer(e);
    this.closeMenu();
  }

  logout(e?: Event) {
    e?.preventDefault();
    this.isOpen = false;

    this.employeeService.handleEmployeeLogout().subscribe();
    this.closeMenu();
  }

  navigateToOverview() {
    const dialogConfig = new MmDialogConfig();

    if (this.isImpersonating) {
      this.mmDialogService.open(EmployeeOverviewNavigationAlertDialogComponent, dialogConfig);
    } else {
      window.location.href = `/${environment.baseHref().replace(new RegExp('\/', 'g'), '')}/${APP_EMPLOYEE_OVERVIEW}`;
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
